import React from 'react';

import { ProblemsStub } from 'common.components/problems-stub/problems-stub';

import './problems__stub.scss';

export const LessonViewProblemsStub = () => {
    return <ProblemsStub mix="problems__stub" textId="lessonView.problems.stub.description" />;
};
